import { bankingCards } from "./Banking";
import { connectorCards } from "./Connectors";
import { spanishCultureCards } from "./Culture";
import { emergencyCards } from "./Emergencies";
import { everydayEncountersCards } from "./Everyday";
import { foodCards } from "./Food";
import { healthcareCards } from "./Healthcare";
import { housingCards } from "./Housing";
import { idiomCards } from "./Idioms";
import { legalCards } from "./Legal";
import { numberCards } from "./Numbers";
import { relationshipCards } from "./Relationships";
import { spanishSlangCards } from "./Slang";
import { travelCards } from "./Travel";
import { workCards } from "./Work";

export const allTemas = [
    ...numberCards,
    ...bankingCards,
    ...spanishCultureCards,
    ...emergencyCards,
    ...everydayEncountersCards,
    ...foodCards,
    ...healthcareCards,
    ...housingCards,
    ...legalCards,
    ...relationshipCards,
    ...spanishSlangCards,
    ...travelCards,
    ...workCards,
    ...connectorCards,
    ...idiomCards
];